import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const MapContainer = styled.div`
  border-radius: 4px;
  position: relative;
  height: 300px;
  overflow: hidden;
  outline: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export const ContentDiv = styled.div`
  max-height: 60vh;
  padding: 0 2.375rem;
  overflow-y: auto;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;
export const SectionContainer = styled.section`
  width: 100%;
`;

export const OuterWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const EditorDescription = styled.div`
  color: #767676;
  margin: 0;
  line-height: 1;
  font-size: 16px;
  padding-left: 10px;
  margin-top: 5px;
  font-size: 14px;
  font-family: lato;
  font-style: normal;
`;
export const EditorDescriptionWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  font-weight: normal;
  margin-top: 10px;
`;
export const EditorDescriptionTitle = styled.div`
  justify-self: auto;
  color: #15aee5;
  font-weight: bold !important;
`;
